export const faqTableHeaders = [
    { key: 'id', label: 'id' },
    { key: 'name', label: 'question' },
    { key: 'description', label: 'answer' },
    { key: 'createdAt', label: 'createdAt' },
    { key: 'updatedAt', label: 'updatedAt' }
];